import styled from 'styled-components';
import Box from '@nubank/nuds-web/components/Box/Box';

import { backgroundImage } from '@nubank/www-latam-commons/components/Image/Image';

export const StyledBox = styled(Box)`
  background-size: cover;

  ${backgroundImage({
    xs: 'mother-and-daugther/mother-and-daugther@0.5x.jpg',
    md: 'mother-and-daugther/mother-and-daugther@0.75x.jpg',
    lg: 'mother-and-daugther/mother-and-daugther@1x.jpg',
    xl: 'mother-and-daugther/mother-and-daugther@2x.jpg',
  })}
`;

StyledBox.displayName = 'StyledBox';
